import { render, staticRenderFns } from "./SideMenuBig.vue?vue&type=template&id=38f17c1d&"
import script from "./SideMenuBig.vue?vue&type=script&lang=js&"
export * from "./SideMenuBig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports